module.exports = __webpack_public_path__ + "media/auto_main_information/badania-techniczne-1ad360d8.svg";